import Vue from 'vue'
import VueResource from 'vue-resource'
import settings from '@/settings'

Vue.use(VueResource)

let apiUrl = settings.apiUrl
let version = settings.version

export default {
  GET_ALL_PACKAGES: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/packages/datatable`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_PACKAGES_LIST: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/packages/list`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_AVAILABLE_PACKAGES: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/packages/available`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_PACKAGE: ({ commit, dispatch }, packageId) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/packages/${packageId}`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  CREATE_PACKAGE: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/packages`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  EDIT_PACKAGE: ({ commit, dispatch }, {packageId, params}) => {
    return new Promise((resolve, reject) => {
      Vue.http.put(`${apiUrl}${version}/packages/${packageId}`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  DELETE_PACKAGES: ({ commit, dispatch }, packageIds) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/packages/delete`, { packages_ids: packageIds }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_WIZARD: ({ commit, dispatch }, wizardType) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/wizards/by-type`, { wizard_type: wizardType }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  BUY_THROUGH_WIZARD: ({ commit, dispatch }, {wizardId, stepsValues}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/wizards/${wizardId}/buy`, { steps_values: stepsValues }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_WIZARD_DISCOUNT: ({ commit, dispatch }, {wizardId, stepsValues}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/wizards/${wizardId}/discount`, { steps_values: stepsValues }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/plan/actions.js